const TEXT_ROWS = {
  VERTICAL: 15,
  STACKED: 13,
  OVERTIME: 8,
  KEY_FINDINGS: 30,
};

export default TEXT_ROWS;
